import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IDeleteDataQualityIndicatorParams {
  contentName: string;
  id: string;
}

export interface IDeleteDataQualityIndicatorResult extends IResult {

}

export class DeleteDataQualityIndicatorRequest extends Request<IDeleteDataQualityIndicatorParams, IDeleteDataQualityIndicatorResult> {
  constructor(params: IDeleteDataQualityIndicatorParams) {
    super('deleteDataQualityIndicator', params);
  }
}